import React, { useEffect } from "react";

import actionArgs from "astrid-distribution/src/actions/actionArgs";

import Form from "../../../../forms/components/Form/Form";

import PipelineStepActionArg from "./PipelineStepActionArg";

function getDefaultValue(arg) {
	switch (arg.type) {
		case "string":
			return "";
		case "boolean":
			return false;
		default:
			return null;
	}
}

export default function PipelineStepActionArgs({ name, action }) {
	const { getValues, setValue } = Form.useFormContext();

	const { watch } = Form.useFormContext();

	const args = watch(`${name}.args`);

	const stepArgs = actionArgs[action];

	useEffect(() => {
		if (stepArgs) {
			const values = getValues(`${name}.args`);

			const defaultValues = stepArgs.reduce(
				(acc, arg) => ({
					...acc,
					[arg.id]: values?.[arg.id] || arg.defaultValue || getDefaultValue(arg),
				}),
				{},
			);

			setValue(`${name}.args`, defaultValues);
		}
	}, [stepArgs, getValues, name, setValue]);

	if (!args) {
		return null;
	}

	return (
		<>
			{stepArgs
				?.filter((arg) => !arg.display || arg.display(args))
				.map((arg) => (
					<PipelineStepActionArg key={arg.id} arg={arg} name={`${name}.args.${arg.id}`} />
				))}
		</>
	);
}
